/* eslint-disable no-unused-expressions */
import type { ApplyChannelData, OrderQueryRealTime, SubmitApplyResultData } from '@/api/apply-product/types';
import { Popup } from 'vant';
import {
  Component, Model, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WaitCountNumberType } from '../../types';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component({
  name: 'CountdownPopup',
})
export default class CountdownPopup extends Vue {
  @ApplyProductStore.State channel!: ApplyChannelData | undefined;

  @ApplyProductStore.State submitResult!: SubmitApplyResultData | undefined;

  @ApplyProductStore.State queryRealTimeStatus!: OrderQueryRealTime

  // 度小满实时查询
  @ApplyProductStore.Action orderQueryRealTime!: () => Promise<void>;

  @Model('change', {
    type: Boolean,
  })
  private visible!: boolean

  /**
   * 页面显示倒计时数字
   * */
  private visiblePageCountNumber = 4

  // 当前鉴权等待时间状态
  private get currentLoanWaitResult() {
    return this.submitResult && this.submitResult.loanWait;
  }

  private onClosePopup(): void {
    this.$emit('change', false);
  }

  private created() {
    this.$ubtModuleExpose(
      'finance_withdrawalApplicationPage_applyingPopup',
      'commodityId',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (this.channel && `${this.channel.productId}`)!,
      'source',
      !this.currentLoanWaitResult ? 'dxmAuthentication' : 'dxmLoanApplication',
    );
    this.visiblePageCountNumber = this.currentLoanWaitResult
      ? WaitCountNumberType.loanWait : WaitCountNumberType.wait;
    if (this.visiblePageCountNumber) {
      this.currentLoanWaitResult ? this.waitCountDownResult() : this.getVisibleCountNo();
    }
  }

  // 等待33s倒计时
  private waitCountDownResult() {
    let time = Number(this.visiblePageCountNumber);
    const timeId = setInterval(async () => {
      time--;
      this.visiblePageCountNumber = time;
      switch (time) {
        case 32:
        case 22:
        case 11:
        case 0:
          await this.checkApllyResult(timeId, time);
          break;
        default:
          break;
      }
    }, 1000);
  }

  // 查询结果
  private async checkApllyResult(timeId: NodeJS.Timer, time: number) {
    await this.orderQueryRealTime();
    if (this.queryRealTimeStatus
      && this.queryRealTimeStatus.contractAdd) {
      this.onClosedCountDown(timeId);
      this.getApplyResult();
    }
    if (!time) {
      this.onClosedCountDown(timeId);
      this.getApplyResult();
    }
  }

  // 等待4s倒计时
  private getVisibleCountNo() {
    let t = Number(this.visiblePageCountNumber);
    const timer = setInterval(() => {
      t--;
      if (t) {
        this.visiblePageCountNumber = t;
      } else {
        this.onClosedCountDown(timer);
        this.getApplyResult();
      }
    }, 1000);
  }

  // 获取请求结果
  private getApplyResult() {
    this.$emit('apply');
  }

  // 关闭弹窗和倒计时
  private onClosedCountDown(timeId: NodeJS.Timer) {
    clearInterval(timeId);
    this.onClosePopup();
  }


  private render() {
    return (
      this.visiblePageCountNumber
      && <div class={style.CountdownPopup}>
        <Popup
          v-model={this.visible}
          closeOnClickOverlay={false}
          class={style.currentPopup}
        >
          <div class={style.mainContent}>
            <div class={style.image}></div>
            <div class={style.textDesc}>
              <div class={style.title}>正在为您申请中({this.visiblePageCountNumber}s)</div>
              <div class={style.tips}>请耐心等待，请勿退出</div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
